<template>
  <template
    v-for="(routeWiseTripIncome, key) in userRouteWiseTripIncome"
    :key="key"
  >
    <template
      v-if="
        routeWiseTripIncome.routeWiseTripIncome &&
        Array.isArray(routeWiseTripIncome.routeWiseTripIncome)
      "
    >
      <template
        v-for="(data, index) in routeWiseTripIncome.routeWiseTripIncome"
        :key="index"
      >
        <div
          class="tab-pane fade"
          :id="
            $format.onlyLetterString(data.route_name) +
            '-' +
            $format.onlyAlphanumericString(key) +
            '-' +
            index
          "
          role="tabpanel"
          :aria-labelledby="
            'nav-' +
            $format.onlyLetterString(data.route_name) +
            '-tab-' +
            $format.onlyAlphanumericString(key) +
            '-' +
            index
          "
        >
          <template v-if="isDateRouteBillSummaryLoading">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-md-12">
              <div class="row">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>KM</th>
                        <th>KM Earning</th>
                        <th>OT Hours</th>
                        <th>OT Earning</th>
                        <th>Lunch</th>
                        <th>Others</th>
                        <th>Total Earnings (Per days)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="data in routeWiseDailyTransaction"
                        :key="data.attendance_id"
                      >
                        <tr>
                          <td>
                            {{ $format.date(data.trip_date) }}
                          </td>
                          <td>
                            {{ data.total_km ? data.total_km + ' KM' : 'N/A' }}
                          </td>
                          <td>
                            {{
                              '৳ ' +
                              $format.floatingPointPlaces(data.trip_income, 2)
                            }}
                          </td>
                          <td>
                            {{
                              data.over_time_hours
                                ? data.over_time_hours + 'h'
                                : 'N/A'
                            }}
                          </td>
                          <td>
                            {{
                              '৳ ' +
                              $format.floatingPointPlaces(data.overtime, 2)
                            }}
                          </td>
                          <td>
                            {{
                              '৳ ' +
                              $format.floatingPointPlaces(
                                data.lunch_allowance,
                                2
                              )
                            }}
                          </td>
                          <td>
                            {{
                              '৳ ' +
                              $format.floatingPointPlaces(data.other_payment, 2)
                            }}
                          </td>
                          <td>
                            {{
                              '৳ ' +
                              $format.floatingPointPlaces(
                                totalEarningsPerDay(data),
                                2
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td colspan="7" style="text-align: right">Total</td>
                        <td>
                          ৳
                          {{
                            $format.floatingPointPlaces(
                              routeWiseDailyEarningCalculation,
                              2
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </template>
  </template>
</template>

<script>
export default {
  props: ['userRouteWiseTripIncome', 'routeWiseDailyTransaction'],
  computed: {
    routeWiseDailyEarningCalculation() {
      let total = 0;

      this.routeWiseDailyTransaction.forEach((data) => {
        total += parseFloat(data.trip_income);
        total += parseFloat(data.overtime);
        total += parseFloat(data.lunch_allowance);
        total += parseFloat(data.other_payment);
      });

      return total;
    }
  },
  methods: {
    totalEarningsPerDay(data) {
      let total = 0;

      total += parseFloat(data.trip_income);
      total += parseFloat(data.overtime);
      total += parseFloat(data.lunch_allowance);
      total += parseFloat(data.other_payment);

      return total;
    }
  }
};
</script>

<style scoped>
table {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0px 0px;
  font-size: 15px;
  align-content: center;
}
table th,
table td {
  vertical-align: middle;
  padding: 0.5rem;
}
table thead {
  background-color: #f3f3f3;
}
table thead tr th {
  font-size: 13px;
  font-weight: 500;
  padding: 11px 15px;
}
table tbody {
  border-top: none !important;
}
table tbody tr td {
  font-size: 13px;
  font-weight: 400;
  padding: 10px 12px;
}
</style>
